import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { IStore, listStores, createStore, updateStore, deleteStore, pageStores } from '../../service/api/store';
import moment from 'moment';
import { FormInstance } from 'antd/lib/form/Form';
import { IAccount,listAccounts } from '../../service/api/account';
const { confirm } = Modal;
const { Option } = Select;

const StoreView = (props: any) => {
  const [stores, setStores] = useState<IStore[]>();
  const [accounts, setAccounts] = useState<IAccount[]>();
  const [storeDetail, setStoreDetail] = useState<IStore>();
  const [storeVisible, setStoreVisible] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const formRef = React.createRef<FormInstance>();

  const columns = [
    {
      title: '门店名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '负责人',
      dataIndex: 'owner',
      key: 'owner',
    },
    {
      title: '地址',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: '开业时间',
      dataIndex: 'openTime',
      key: 'openTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD') : <>&mdash;</>
      },
    },
    {
      title: '学员数量',
      dataIndex: 'studentCount',
      key: 'studentCount',
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: IStore) => (
        <Space size="middle">
          <a onClick={() => {
            // console.log("record:" + JSON.stringify(record));
            // if(typeof(record.openTime) === 'string') {
            //   record.openTime = moment(new Date(record.openTime)).add(8, 'hour')
            // }
            setStoreDetail(record);
            setStoreVisible(true);
          }}>编辑 </a>
          <a target="_blank" href={'#/app/store/classroom?storeId='+record.id+'&&storeName='+record.name} >教室管理 </a>
          {/* <a onClick={e=>{onDelete(e,record)}}>删除 </a> */}
        </Space>
      ),
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (storeDetail) {
      let copyFormData = JSON.parse(JSON.stringify(storeDetail))
      if(typeof(copyFormData.openTime) === 'string') {
        copyFormData.openTime = moment(new Date(storeDetail.openTime));
      }
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(copyFormData);
      }, 100);
    }
  }, [storeDetail]);

  const loadData = () => {
    pageStores(pageNum, pageSize).then((info: any) => {
      setStores(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
    // listAccounts().then((info: any) => {
    //   setAccounts(info?.data);
    // });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (storeDetail) {
      updateStore({
        ...values,
        id: storeDetail.id
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if(info){
        message.success("更新成功");
        setStoreVisible(false);
        setStoreDetail(undefined);
        setLoading(false);
        loadData();
        }
      });
    } else {
      createStore(values).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if(info){
        message.success("创建成功");
        setStoreVisible(false);
        setStoreDetail(undefined);
        setLoading(false);
        loadData();
        }
      });
    }
  };

  // const onDelete = (e: any, item: IStore) => {
  //   e.stopPropagation();
  //   confirm({
  //     title: '提示',
  //     icon: <ExclamationCircleOutlined />,
  //     content: '确定要删除该门店吗？删除后无法恢复',
  //     okText: '确定',
  //     okType: 'danger',
  //     cancelText: '取消',
  //     onOk() {
  //       deleteStore(item.id).then((info: any) => {
  //         console.log("info:" + JSON.stringify(info));
  //         message.success("删除成功");
  //         loadData();
  //       });
  //     },
  //     onCancel() {
  //     },
  //   });
  // }

  const onClose = () => {
    setStoreDetail(undefined);
    setStoreVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    console.log("pageNum:" + pageNum);
    console.log("pageSize:" + pageSize);
    setPageNum(pageNum);
    setPageSize(pageSize||10);
    // setPageSize(info.data.pageSize);
  }


  function onDateChange(value: any, dateString: any) {
    console.log('Selected Time: ', value);
    console.log('Formatted Selected Time: ', dateString);
  }

  function onDateOk(value: moment.MomentInput) {
    console.log('onOk: ', value);
    value = moment(value).format('YYYY-MM-DD HH:mm:ss') //这么解决的
  }

  // 下拉框值
  const accountOptions = accounts?.map((account) =>
    <Option key={account.id} value={account.id}>{account.username}</Option>);

  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={['门店管理']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Card title="门店管理" bordered={false} extra={
              <Button type="primary" onClick={() => {
                setStoreVisible(true);
              }} icon={<PlusOutlined />}>
                新增
              </Button>
            }>
              <Table dataSource={stores} columns={columns} pagination={false} />
              <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
                <Pagination
                  defaultCurrent={pageNum}
                  total={pageTotal}
                  pageSize={pageSize}
                  hideOnSinglePage={false}
                  className="pagination"
                  onChange={onPageChange}
                  showSizeChanger
                  showTotal={total => `共计 ${total} 条`}
                />
              </div>
            </Card>
          </div>
        </Col>
      </Row>
      <Drawer
        title={storeDetail ? "编辑门店" : "新增门店"}
        visible={storeVisible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="门店名"
                rules={[{ required: true, message: '请输入门店名' }]}
              >
                <Input placeholder="请输入门店名" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="owner"
                label="负责人"
                rules={[{ required: false, message: '请输入负责人' }]}
              >
                {/* <Select placeholder="请选择负责人"  >
                  {accountOptions}
                </Select> */}
                <Input placeholder="请输入负责人" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="address"
                label="地址"
                required={true}
                rules={[{ required: false, message: '请输入地址' }]}
              >
                <Input placeholder="请输入地址" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="code"
                label="门店编码（用于生成学员学号）"
                rules={[{ required: true, message: '请输入' }]}
              >
                <Input placeholder="请输入" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="openTime"
                label="开业时间"
                rules={[{ required: false, message: '请填写开业时间' }]}
              >
                <DatePicker
                  value={moment(storeDetail?.openTime)}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

export default StoreView;
